import TabbedPage from '../TabbedPage';
import React from 'react';
import OverWindow from './OverWindow';
import ButtonTypeEnum from '../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../Enums/IconPositionEnum';
import FigmaButton from '../FigmaButton';

export default class GenericOverWindow extends React.Component {
  static defaultProps = {
    windowDescription: {
      getTabs: () => [
        //An example of the object that should be in the array returned by getTabs function
        // {
        //   label: 'Example Label',
        //   id: 'example_id',
        //   icon: 'fa-solid fa-circle',
        //   component: <div>Example Component</div>,
        // },
      ],
      getTitle: () => {},
      description: null,
    },
    clickOnCancel: () => {
      alert('Missing function');
    },
    clickOnOk: null,
    // Selected-row data the window description renders from. It is handed over as a prop - and
    // not read by the description off a mutable static - so that two components can open the same
    // window without overwriting each other's selection.
    filterParameters: null,
  };

  render() {
    if (!this.props.windowDescription?.getTitle) {
      throw new Error(
        'GenericOverWindow: No title provided in windowDescription. Title is required for the over window.'
      );
    }
    if (!this.props.clickOnCancel) {
      throw new Error(
        'GenericOverWindow: No clickOnCancel function provided. This function is required for the over window.'
      );
    }

    const tabs = this.props.windowDescription.getTabs
      ? this.props.windowDescription.getTabs(this.props.filterParameters)
      : [];
    return (
      <OverWindow
        clickOnCancel={this.props.clickOnCancel}
        title={this.props.windowDescription.getTitle(this.props.filterParameters)}
        closeOnClickOutside={false}
      >
        <div className='verticalScroll showassignmentlistheight'>
          {this.props.windowDescription.description ? (
            <div className='center'>{this.props.windowDescription.description}</div>
          ) : null}
          <TabbedPage tabs={tabs} />
          {this.props.clickOnOk ? (
            <div className='EditBoxFooter'>
              <FigmaButton
                label='Ok'
                className='EditBoxFooterRight'
                type={ButtonTypeEnum.NormalIconRight}
                color={ButtonColorsEnum.Secondary}
                iconPosition={IconPositionEnum.None}
                onClick={this.props.clickOnOk}
              />
            </div>
          ) : null}
        </div>
      </OverWindow>
    );
  }
}
